// Web-only entry point
// This file is used by web builds (Rspack/Webpack)

import { default as nativeStorage } from './native';
import { IStorage } from './types';
import { default as webStorage } from './web';

export * from './types';

const storage = __WEB__ ? webStorage : (nativeStorage as IStorage);

export default storage;
